"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Return a string with format "time name"
 * @param {String} name
 * @param {Number} time
 * @returns {String}
 */
var formatTiming = exports.formatTiming = function formatTiming(name, time) {
  return Math.round(time) + " " + name;
};

/**
 * Convert an object to an array of formatTiming strings [ 'obj.value obj.key' ]
 * @param {Object} object
 * @returns {Array}
 */
var objectToTimingArray = exports.objectToTimingArray = function objectToTimingArray(o) {
  return Object.keys(o).map(function (key) {
    return formatTiming(key, o[key]);
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/client-profiler-core/dist/utils/formatTiming.js
// module id = 417
// module chunks = 5